import { render } from "./EmailIcon.vue?vue&type=template&id=38796c42&scoped=true"
import script from "./EmailIcon.vue?vue&type=script&lang=js"
export * from "./EmailIcon.vue?vue&type=script&lang=js"

import "./EmailIcon.vue?vue&type=style&index=0&id=38796c42&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38796c42"]])

export default __exports__